import ChangelogContainer from './ChangelogContainer';

export default ChangelogContainer;
